if (!customElements.get('scroll-slider-claude')) {
  class ScrollSliderClaude extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ssc__track');
      if (!this.track) return;
      this.prevBtns = Array.from(this.querySelectorAll('[data-ssc-prev]'));
      this.nextBtns = Array.from(this.querySelectorAll('[data-ssc-next]'));
      this.bar = this.querySelector('[data-ssc-bar]');
      this.prevBtns.forEach((b) => b.addEventListener('click', () => this.move(-1)));
      this.nextBtns.forEach((b) => b.addEventListener('click', () => this.move(1)));
      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.loop = this.dataset.loop === 'true' && this.track.children.length > 1;
      if (this.loop) this.setupLoop();
      this.ro = new ResizeObserver(() => this.update());
      this.ro.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      if (this.onLoopScroll) this.track?.removeEventListener('scroll', this.onLoopScroll);
      this.ro?.disconnect();
    }

    setupLoop() {
      const track = this.track;
      const originals = Array.from(track.children);
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();
      originals.forEach((el) => { const c = el.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.dataset.clone = '1'; before.appendChild(c); });
      originals.forEach((el) => { const c = el.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.dataset.clone = '1'; after.appendChild(c); });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
      this.setWidth = () => track.scrollWidth / 3;
      requestAnimationFrame(() => this.jump(this.setWidth()));
      this.onLoopScroll = () => {
        const w = this.setWidth();
        if (w <= 0 || this.jumping) return;
        if (track.scrollLeft < w * 0.35) this.jump(track.scrollLeft + w);
        else if (track.scrollLeft > w * 1.65) this.jump(track.scrollLeft - w);
      };
      track.addEventListener('scroll', this.onLoopScroll, { passive: true });
    }

    jump(x) {
      const track = this.track;
      this.jumping = true;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = x;
      requestAnimationFrame(() => {
        track.style.scrollBehavior = '';
        track.style.scrollSnapType = '';
        this.jumping = false;
      });
    }

    step() {
      const slide = this.track.querySelector('.ssc__slide');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    move(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      if (this.loop) {
        this.prevBtns.forEach((b) => (b.disabled = false));
        this.nextBtns.forEach((b) => (b.disabled = false));
      } else {
        this.prevBtns.forEach((b) => (b.disabled = x <= 2));
        this.nextBtns.forEach((b) => (b.disabled = x >= max - 2));
      }
      if (this.bar) {
        const ratio = max > 0 ? Math.min(1, this.track.clientWidth / this.track.scrollWidth) : 1;
        const pos = max > 0 ? x / max : 0;
        this.bar.style.width = ratio * 100 + '%';
        this.bar.style.transform = 'translateX(' + pos * (100 / ratio - 100) + '%)';
      }
    }
  }
  customElements.define('scroll-slider-claude', ScrollSliderClaude);
}

if (!customElements.get('quick-add-claude')) {
  class QuickAddClaude extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-qa-toggle]');
      this.panel = this.querySelector('.pc__qa-panel');
      this.btnLabel = this.querySelector('[data-qa-label]');
      this.defaultLabel = this.btnLabel ? this.btnLabel.textContent : '';
      this.btn?.addEventListener('click', (e) => { e.stopPropagation(); this.toggle(); });
      this.querySelector('[data-qa-close]')?.addEventListener('click', () => this.toggle(false));
      this.querySelectorAll('[data-qa-id]').forEach((row) => row.addEventListener('click', () => this.add(row)));
    }

    disconnectedCallback() {
      this.unbind();
    }

    toggle(force) {
      const open = force !== undefined ? force : !this.classList.contains('is-open');
      if (open) {
        document.querySelectorAll('quick-add-claude.is-open').forEach((el) => { if (el !== this) el.toggle(false); });
        this.place();
        this.classList.add('is-open');
        this.bind();
      } else {
        this.classList.remove('is-open');
        this.unbind();
      }
      this.btn?.setAttribute('aria-expanded', String(open));
    }

    place() {
      const r = this.btn.getBoundingClientRect();
      const p = this.panel;
      p.style.width = Math.max(220, r.width) + 'px';
      p.style.left = '0px';
      p.style.top = '0px';
      const h = p.offsetHeight;
      const below = window.innerHeight - r.bottom;
      const openDown = below > h + 16 || below > r.top;
      p.dataset.place = openDown ? 'bottom' : 'top';
      const top = openDown ? r.bottom + 8 : r.top - h - 8;
      let left = Math.min(r.left, window.innerWidth - p.offsetWidth - 10);
      p.style.left = Math.max(10, left) + 'px';
      p.style.top = Math.max(10, top) + 'px';
    }

    bind() {
      this.onOutside = (e) => { if (!this.contains(e.target)) this.toggle(false); };
      this.onEsc = (e) => { if (e.key === 'Escape') { this.toggle(false); this.btn.focus(); } };
      this.onMove = () => this.toggle(false);
      this.trackEl = this.closest('.ssc')?.querySelector('.ssc__track');
      setTimeout(() => document.addEventListener('click', this.onOutside), 0);
      document.addEventListener('keydown', this.onEsc);
      window.addEventListener('scroll', this.onMove, { passive: true });
      window.addEventListener('resize', this.onMove);
      this.trackEl?.addEventListener('scroll', this.onMove, { passive: true });
    }

    unbind() {
      if (!this.onOutside) return;
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('keydown', this.onEsc);
      window.removeEventListener('scroll', this.onMove);
      window.removeEventListener('resize', this.onMove);
      this.trackEl?.removeEventListener('scroll', this.onMove);
    }

    async add(row) {
      if (row.disabled || this.busy) return;
      this.busy = true;
      row.classList.add('is-added');
      try {
        if (window.CartDrawerClaude) {
          await window.CartDrawerClaude.add(row.dataset.qaId, 1);
        } else {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(row.dataset.qaId), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('add failed');
          ['cart:updated', 'cart:refresh', 'cart:change'].forEach((ev) => document.dispatchEvent(new CustomEvent(ev, { bubbles: true })));
        }
        if (this.btnLabel) this.btnLabel.textContent = this.dataset.addedLabel || 'Ajouté au panier';
        this.classList.add('is-done');
        setTimeout(() => {
          this.classList.remove('is-done');
          row.classList.remove('is-added');
          if (this.btnLabel) this.btnLabel.textContent = this.defaultLabel;
          this.toggle(false);
        }, 1400);
      } catch (e) {
        row.classList.remove('is-added');
        if (this.btnLabel) this.btnLabel.textContent = 'Réessayer';
        setTimeout(() => { if (this.btnLabel) this.btnLabel.textContent = this.defaultLabel; }, 2000);
      } finally {
        this.busy = false;
      }
    }
  }
  customElements.define('quick-add-claude', QuickAddClaude);
}
